import React from 'react';

export default function HomeMarquee({ song }) {
  return (
    <div className="mt-16 w-full hairline-t hairline-b py-3 overflow-hidden">
      <div className="marquee-track font-display text-3xl md:text-4xl">
        <span className="px-6">— NOW PLAYING ·</span>
        <span className="px-6">{song}</span>
        <span className="px-6">· OSO LONDON ·</span>
        <span className="px-6">LIVE FROM LONDON ·</span>
        <span className="px-6">— NOW PLAYING ·</span>
        <span className="px-6">{song}</span>
        <span className="px-6">· OSO LONDON ·</span>
        <span className="px-6">LIVE FROM LONDON ·</span>
      </div>
    </div>
  );
}
